export default "__VITE_ASSET__CiloBQbJ__"